import React from "react";
import { Header } from "Components/DP/DPTable/DPTable";
import { DPTable, DPEmptyTable, DPComponentLoader } from "Components/DP";
import UserRosterTableRow from "../UserRosterTableRow/UserRosterTableRow";
import { useUserRosterTable } from "./useUserRosterTable";
import { usePartnerConfig } from "Hooks/usePartnerConfig";

const userRosterHeaders: Header[] = [
  "Date/Time",
  "Uploader",
  "File Name",
  "Status",
  "Submission",
];

const UserRosterTable = () => {
  const { permissions } = usePartnerConfig();

  const headers = permissions.canViewBatchOnboard
    ? userRosterHeaders
    : userRosterHeaders.filter(h => h !== "Submission");

  const {
    loading,
    page,
    rowsPerPage,
    totalCount,
    data,
    onChangePageFn,
  } = useUserRosterTable();

  return (
    <DPTable
      page={page}
      rowsPerPage={rowsPerPage}
      count={totalCount}
      headers={headers}
      onChangePage={onChangePageFn}
      colWidths={[26, 17, 15.6, 14, 5]}
    >
      <DPComponentLoader
        isLoading={loading}
        kind={"table"}
        awaitComponent={
          data && data.batchOnboardFiles.items.length ? (
            <>
              {data.batchOnboardFiles.items.map(file => (
                <UserRosterTableRow key={file.id} onboardFile={file} />
              ))}
            </>
          ) : (
            <DPEmptyTable message={"Uploads will appear here once created"} />
          )
        }
      />
    </DPTable>
  );
};

export default UserRosterTable;
